import { drawContours } from "./drawV2.js"; 

const detectFaceAndEyesV2 = async (
  webcamElement,
  canvasElement,
  fixedCanvasWidth,
  fixedCanvasHeight,
  predictions,
  lightingScore,
  previousLightingScore,
  finalImageWidth,
  finalImageHeight,
  isLandscapeMode
//   counter
) => {
  const states = {
    fixedCanvasWidth,
    fixedCanvasHeight,
    lightingScore,
    previousLightingScore,
    finalImageWidth,
    finalImageHeight,
    isLandscapeMode
    // counter,
  };
  if (webcamElement.readyState !== 4) {
    return;
  }
  if (predictions.faceLandmarks && predictions.faceLandmarks.length === 1) {
    let keypoints = [];
    for (let i = 0; i < predictions.faceLandmarks[0].length; i++) {
      keypoints.push({
        x: predictions.faceLandmarks[0][i].x * fixedCanvasWidth,
        y: predictions.faceLandmarks[0][i].y * fixedCanvasHeight,
      });
    }

    const [xri, yri] = [keypoints[468].x, keypoints[468].y]; // right iris
    const [xli, yli] = [keypoints[473].x, keypoints[473].y]; // left iris

    const [xrui, yrui] = [keypoints[469].x, keypoints[469].y]; // right eye upper iris point
    const [xrri, yrri] = [keypoints[470].x, keypoints[470].y]; // right eye right iris point
    const [xrdi, yrdi] = [keypoints[471].x, keypoints[471].y]; // right eye down iris point
    const [xrli, yrli] = [keypoints[472].x, keypoints[472].y]; // right eye left iris point

    const [xlui, ylui] = [keypoints[474].x, keypoints[474].y]; // left eye upper iris point
    const [xlri, ylri] = [keypoints[475].x, keypoints[475].y]; // left eye right iris point
    const [xldi, yldi] = [keypoints[476].x, keypoints[476].y]; // left eye down iris point
    const [xlli, ylli] = [keypoints[477].x, keypoints[477].y]; // left eye left iris point

    let faceContour = [];

    faceContour.push([keypoints[234].x, keypoints[234].y]);
    faceContour.push([keypoints[127].x, keypoints[127].y]);
    faceContour.push([keypoints[21].x, keypoints[21].y]);
    faceContour.push([keypoints[54].x, keypoints[54].y]);
    faceContour.push([keypoints[103].x, keypoints[103].y]);
    faceContour.push([keypoints[67].x, keypoints[67].y]);
    faceContour.push([keypoints[109].x, keypoints[109].y]);
    faceContour.push([keypoints[10].x, keypoints[10].y]);
    faceContour.push([keypoints[338].x, keypoints[338].y]);
    faceContour.push([keypoints[297].x, keypoints[297].y]);
    faceContour.push([keypoints[332].x, keypoints[332].y]);
    faceContour.push([keypoints[284].x, keypoints[284].y]);
    faceContour.push([keypoints[251].x, keypoints[251].y]);
    faceContour.push([keypoints[389].x, keypoints[389].y]);
    faceContour.push([keypoints[356].x, keypoints[356].y]);
    faceContour.push([keypoints[454].x, keypoints[454].y]);
    faceContour.push([keypoints[323].x, keypoints[323].y]);
    faceContour.push([keypoints[361].x, keypoints[361].y]);
    faceContour.push([keypoints[288].x, keypoints[288].y]);
    faceContour.push([keypoints[397].x, keypoints[397].y]);
    faceContour.push([keypoints[365].x, keypoints[365].y]);
    faceContour.push([keypoints[379].x, keypoints[379].y]);
    faceContour.push([keypoints[378].x, keypoints[378].y]);
    faceContour.push([keypoints[400].x, keypoints[400].y]);
    faceContour.push([keypoints[377].x, keypoints[377].y]);
    faceContour.push([keypoints[152].x, keypoints[152].y]);
    faceContour.push([keypoints[148].x, keypoints[148].y]);
    faceContour.push([keypoints[176].x, keypoints[176].y]);
    faceContour.push([keypoints[149].x, keypoints[149].y]);
    faceContour.push([keypoints[150].x, keypoints[150].y]);
    faceContour.push([keypoints[136].x, keypoints[136].y]);
    faceContour.push([keypoints[172].x, keypoints[172].y]);
    faceContour.push([keypoints[58].x, keypoints[58].y]);
    faceContour.push([keypoints[132].x, keypoints[132].y]);
    faceContour.push([keypoints[93].x, keypoints[93].y]);
    faceContour.push([keypoints[234].x, keypoints[234].y]);

    const radiusLeft =
      (Math.sqrt((xli - xlui) * (xli - xlui) + (yli - ylui) * (yli - ylui)) +
        Math.sqrt((xli - xlri) * (xli - xlri) + (yli - ylri) * (yli - ylri)) +
        Math.sqrt((xli - xldi) * (xli - xldi) + (yli - yldi) * (yli - yldi)) +
        Math.sqrt((xli - xlli) * (xli - xlli) + (yli - ylli) * (yli - ylli))) /
      4;

    const radiusRight =
      (Math.sqrt((xri - xrui) * (xri - xrui) + (yri - yrui) * (yri - yrui)) +
        Math.sqrt((xri - xrri) * (xri - xrri) + (yri - yrri) * (yri - yrri)) +
        Math.sqrt((xri - xrdi) * (xri - xrdi) + (yri - yrdi) * (yri - yrdi)) +
        Math.sqrt((xri - xrli) * (xri - xrli) + (yri - yrli) * (yri - yrli))) /
      4;

    let width = webcamElement.width > webcamElement.height ? finalImageWidth : finalImageHeight;
    let height = webcamElement.width > webcamElement.height ? finalImageHeight : finalImageWidth;
    let actualWidth = isLandscapeMode ? width : height;
    let eye_size = false;
    const rightEyeL = 362;
    const rightEyeR = 263;
    const leftEyeL = 33;
    const leftEyeR = 133;
    const reyew = Math.abs(keypoints[rightEyeL].x - keypoints[rightEyeR].x);
    const leyew = Math.abs(keypoints[leftEyeL].x - keypoints[leftEyeR].x);
    if (reyew > 260 * (webcamElement.width / actualWidth) && leyew > 260 * (webcamElement.width / actualWidth)) {
    // if (reyew > 30 * (webcamElement.width / actualWidth) && leyew > 30 * (webcamElement.width / actualWidth)) {
      eye_size = true;
    }

    let isCloser = false;
    const xbound1 = keypoints[143].x;
    const xbound2 = keypoints[372].x;
    const ybound1 = keypoints[105].y;
    const ybound2 = keypoints[334].y;
    const ybound3 = keypoints[199].y;
    if (xbound1 < 0 || xbound1 > canvasElement.width || xbound2 < 0 || xbound2 > canvasElement.width) {
      isCloser = true;
    }
    if (
      ybound1 < 0 ||
      ybound1 > canvasElement.height ||
      ybound2 < 0 ||
      ybound2 > canvasElement.height ||
      ybound3 < 0 ||
      ybound3 > canvasElement.height
    ) {
      isCloser = true;
    }
    if (reyew > 550 * (canvasElement.width / actualWidth) && leyew > 550 * (canvasElement.width / actualWidth)) {
      isCloser = true;
    }
    const distance = eye_size && !isCloser;
    const drawResult = await drawContours(
      webcamElement,
      canvasElement,
      xli,
      xri,
      yli,
      yri,
      radiusLeft,
      radiusRight,
      faceContour,
      distance,
      states
    );

    let right = false;
    let left = false;
    let up = false;
    let center = false;

    let cencoeffs = [
      49.206399, -53.712047, 51.184116, -37.299901, 19.614215, -12.271274, -6.836239, 6.12812, -20.093458, 13.776093,
      -66.626849, 11.326702, -65.070366, 8.285618, 18.375283, -13.868829, 47.738885, -32.854995, 29.161293, -32.146579,
      -38.210361, -47.974144, -66.850057, -17.894277, -43.672832, 38.58362, 0.698804, 54.911045, 16.817198, 23.209807,
      42.838356, -12.701653, 6.218783, 20.099497, 169.404058, 26.277657, 34.715883, 17.533939, -147.388536, 4.217909,
      -25.721038, 33.555403, -51.32812, -24.609991, -46.334134, -20.250979, 27.154457, -14.522277, 62.374392, 4.403326,
      47.849394, 41.113297, 20.337747, 49.036436, -14.178982, 14.070395, -53.213621, -34.355526, -58.739448, -75.928568,
      -38.510634, -24.352041, -1.016499, 22.569213, 18.195896, 63.913295, 63.651917, 57.122325, 75.412473, 7.057743,
      25.895202, -30.293448, -39.522939, -23.503144, -19.335361, -1.718609, 117.203207, -38.63621, -34.814489,
      -3.669085, -131.264116, 30.889227, 24.603945, 5.154495,
    ];
    let rcoeffs = [
      4.500466, -24.061206, 8.835541, -26.697884, 17.627809, -27.408843, 25.963279, -22.1036, 24.260118, -7.499441,
      13.72743, 6.060091, 7.182226, 8.146636, 4.313502, 1.781642, 3.767015, 0.261793, 6.681246, -0.076398, 12.317884,
      2.423373, 18.122602, 6.091806, 18.464492, 8.948087, 12.808786, 8.935974, 6.742372, 2.981642, 1.998146, -7.521691,
      -35.201325, 18.898814, -56.436387, 24.940826, -39.397735, 5.121951, -11.636733, 13.889405, -31.58111, 32.323623,
      7.164471, -24.0209, 7.628731, -21.297522, 6.503114, -1.945673, 9.614885, 20.938271, 3.105131, 30.10488, -0.989253,
      26.861231, 2.862216, 14.221599, 9.015319, 2.579304, 20.143233, -7.734375, 19.053565, -10.925231, 19.183906,
      -9.648542, 17.845302, -4.409687, 12.222267, 1.331961, 7.910629, -0.373086, 7.443815, -10.394609, 8.555685,
      -19.525642, -35.339295, -0.748305, -25.554713, 0.67034, -24.323261, -33.824504, -42.638304, -2.507021, -45.356739,
      29.233317,
    ];
    let lcoeffs = [
      -16.814546, -8.547422, -10.747009, -6.490112, -3.885134, -5.04921, -1.453368, -2.683826, -2.845557, -5.367522,
      2.214711, -11.339303, 8.484097, -20.301967, -3.352916, -20.790052, -7.623388, -12.475923, -9.001213, -9.014,
      -2.306917, 1.860576, -4.109778, 11.928641, -13.760978, 10.75887, -22.577741, 3.096439, -22.013306, -2.506859,
      -21.002113, -6.218863, 26.373317, 15.677916, -15.166383, 19.363248, 16.055449, -10.497608, 64.434875, 14.237597,
      38.695729, 42.979201, 0.628495, -11.218475, -0.197957, -3.671252, -8.410044, 16.621742, -8.222247, 32.591128,
      -11.952887, 27.912706, -13.340158, 10.363587, -8.730729, -5.572957, -2.977714, -14.74475, -0.662319, -22.461028,
      0.805394, -13.657183, -2.44792, -6.703908, -6.37818, -0.588903, -18.887847, 1.967492, -22.236518, -0.041859,
      -14.397924, -7.418191, -3.577088, -12.660114, 28.132023, 2.490346, -58.821771, 11.436384, 25.105222, -9.125023,
      105.87075, -6.016323, 22.643996, 14.690457,
    ];
    let upcoeffs = [
      22.406888, 37.07409, 16.030472, 34.840261, 10.828343, 29.13262, -1.314431, 15.319122, -41.769735, 0.320958,
      -85.75257, -7.679789, -96.045776, 18.806694, -37.207816, 51.832209, -5.04321, 48.333519, 12.602815, 37.603897,
      9.01284, 13.390523, 11.461013, -9.348503, 31.580711, -11.999679, 47.858146, -4.627315, 45.869964, 6.193538,
      40.137638, 19.142899, -5.51863, -48.863347, 109.465533, -69.421188, 30.564847, -10.726172, -107.973499,
      -40.188054, -55.02026, -102.285815, 2.536129, 32.454703, 30.204581, 38.218352, 78.757928, 5.263925, 65.13139,
      -49.622882, 22.774147, -72.155607, -9.704517, -55.75354, -19.22188, -8.038975, -17.74072, 30.246091, -32.430993,
      64.787171, -25.92573, 66.018303, -28.150191, 56.54334, -28.1168, 27.105783, -7.087394, -6.498448, 0.125903,
      -14.242915, -5.361157, 10.329678, -6.699178, 28.630319, 2.261259, -30.142083, 99.244396, -48.938835, 9.992385,
      76.387695, -93.070075, -11.275666, 11.545183, -149.74506,
    ];
    let dfeatures = [
      parseFloat(keypoints[33].x / fixedCanvasWidth),
      parseFloat(keypoints[33].y / fixedCanvasHeight),
      parseFloat(keypoints[246].x / fixedCanvasWidth),
      parseFloat(keypoints[246].y / fixedCanvasHeight),
      parseFloat(keypoints[161].x / fixedCanvasWidth),
      parseFloat(keypoints[161].y / fixedCanvasHeight),
      parseFloat(keypoints[160].x / fixedCanvasWidth),
      parseFloat(keypoints[160].y / fixedCanvasHeight),
      parseFloat(keypoints[159].x / fixedCanvasWidth),
      parseFloat(keypoints[159].y / fixedCanvasHeight),
      parseFloat(keypoints[158].x / fixedCanvasWidth),
      parseFloat(keypoints[158].y / fixedCanvasHeight),
      parseFloat(keypoints[157].x / fixedCanvasWidth),
      parseFloat(keypoints[157].y / fixedCanvasHeight),
      parseFloat(keypoints[173].x / fixedCanvasWidth),
      parseFloat(keypoints[173].y / fixedCanvasHeight),
      parseFloat(keypoints[133].x / fixedCanvasWidth),
      parseFloat(keypoints[133].y / fixedCanvasHeight),
      parseFloat(keypoints[155].x / fixedCanvasWidth),
      parseFloat(keypoints[155].y / fixedCanvasHeight),
      parseFloat(keypoints[154].x / fixedCanvasWidth),
      parseFloat(keypoints[154].y / fixedCanvasHeight),
      parseFloat(keypoints[153].x / fixedCanvasWidth),
      parseFloat(keypoints[153].y / fixedCanvasHeight),
      parseFloat(keypoints[145].x / fixedCanvasWidth),
      parseFloat(keypoints[145].y / fixedCanvasHeight),
      parseFloat(keypoints[144].x / fixedCanvasWidth),
      parseFloat(keypoints[144].y / fixedCanvasHeight),
      parseFloat(keypoints[163].x / fixedCanvasWidth),
      parseFloat(keypoints[163].y / fixedCanvasHeight),
      parseFloat(keypoints[7].x / fixedCanvasWidth),
      parseFloat(keypoints[7].y / fixedCanvasHeight),
      parseFloat(keypoints[468].x / fixedCanvasWidth),
      parseFloat(keypoints[468].y / fixedCanvasHeight),
      parseFloat(keypoints[469].x / fixedCanvasWidth),
      parseFloat(keypoints[469].y / fixedCanvasHeight),
      parseFloat(keypoints[470].x / fixedCanvasWidth),
      parseFloat(keypoints[470].y / fixedCanvasHeight),
      parseFloat(keypoints[471].x / fixedCanvasWidth),
      parseFloat(keypoints[471].y / fixedCanvasHeight),
      parseFloat(keypoints[472].x / fixedCanvasWidth),
      parseFloat(keypoints[472].y / fixedCanvasHeight),
      parseFloat(keypoints[362].x / fixedCanvasWidth),
      parseFloat(keypoints[362].y / fixedCanvasHeight),
      parseFloat(keypoints[398].x / fixedCanvasWidth),
      parseFloat(keypoints[398].y / fixedCanvasHeight),
      parseFloat(keypoints[384].x / fixedCanvasWidth),
      parseFloat(keypoints[384].y / fixedCanvasHeight),
      parseFloat(keypoints[385].x / fixedCanvasWidth),
      parseFloat(keypoints[385].y / fixedCanvasHeight),
      parseFloat(keypoints[386].x / fixedCanvasWidth),
      parseFloat(keypoints[386].y / fixedCanvasHeight),
      parseFloat(keypoints[387].x / fixedCanvasWidth),
      parseFloat(keypoints[387].y / fixedCanvasHeight),
      parseFloat(keypoints[388].x / fixedCanvasWidth),
      parseFloat(keypoints[388].y / fixedCanvasHeight),
      parseFloat(keypoints[466].x / fixedCanvasWidth),
      parseFloat(keypoints[466].y / fixedCanvasHeight),
      parseFloat(keypoints[263].x / fixedCanvasWidth),
      parseFloat(keypoints[263].y / fixedCanvasHeight),
      parseFloat(keypoints[249].x / fixedCanvasWidth),
      parseFloat(keypoints[249].y / fixedCanvasHeight),
      parseFloat(keypoints[390].x / fixedCanvasWidth),
      parseFloat(keypoints[390].y / fixedCanvasHeight),
      parseFloat(keypoints[373].x / fixedCanvasWidth),
      parseFloat(keypoints[373].y / fixedCanvasHeight),
      parseFloat(keypoints[374].x / fixedCanvasWidth),
      parseFloat(keypoints[374].y / fixedCanvasHeight),
      parseFloat(keypoints[380].x / fixedCanvasWidth),
      parseFloat(keypoints[380].y / fixedCanvasHeight),
      parseFloat(keypoints[381].x / fixedCanvasWidth),
      parseFloat(keypoints[381].y / fixedCanvasHeight),
      parseFloat(keypoints[382].x / fixedCanvasWidth),
      parseFloat(keypoints[382].y / fixedCanvasHeight),
      parseFloat(keypoints[473].x / fixedCanvasWidth),
      parseFloat(keypoints[473].y / fixedCanvasHeight),
      parseFloat(keypoints[474].x / fixedCanvasWidth),
      parseFloat(keypoints[474].y / fixedCanvasHeight),
      parseFloat(keypoints[475].x / fixedCanvasWidth),
      parseFloat(keypoints[475].y / fixedCanvasHeight),
      parseFloat(keypoints[476].x / fixedCanvasWidth),
      parseFloat(keypoints[476].y / fixedCanvasHeight),
      parseFloat(keypoints[477].x / fixedCanvasWidth),
      parseFloat(keypoints[477].y / fixedCanvasHeight),
    ];

    const cb = -0.76586427;
    const rb = -0.63418015;
    const lb = -2.54614929;
    const ub = -0.05258532;
    let upvalue = 0;
    let rvalue = 0;
    let lvalue = 0;
    let cvalue = 0;

    for (let i = 0; i < upcoeffs.length; i += 1) {
      upvalue = upvalue + upcoeffs[i] * dfeatures[i];
      rvalue = rvalue + rcoeffs[i] * dfeatures[i];
      lvalue = lvalue + lcoeffs[i] * dfeatures[i];
      cvalue = cvalue + cencoeffs[i] * dfeatures[i];
    }

    upvalue = 1 / (1 + Math.exp(-1 * (upvalue + ub)));
    rvalue = 1 / (1 + Math.exp(-1 * (rvalue + rb)));
    lvalue = 1 / (1 + Math.exp(-1 * (lvalue + lb)));
    cvalue = 1 / (1 + Math.exp(-1 * (cvalue + cb)));

    if (rvalue === Math.max(upvalue, rvalue, lvalue, cvalue) || rvalue > 0.65) {
      right = true;
    }
    if (lvalue === Math.max(upvalue, rvalue, lvalue, cvalue || lvalue > 0.65)) {
      left = true;
    }
    if (upvalue === Math.max(upvalue, rvalue, lvalue, cvalue) || upvalue > 0.55) {
      up = true;
    }
    if (cvalue === Math.max(upvalue, rvalue, lvalue, cvalue) || cvalue > 0.65) {
      center = true;
    }
    let rr = (radiusRight * 100) / fixedCanvasWidth;
    let rl = (radiusLeft * 100) / fixedCanvasWidth;

    return {
      drawResult,
      keypoints,
      rr,
      rl,
      eye_size,
      position: [center, right, left, up],
    };
  } else {
    
    return await drawContours(webcamElement, canvasElement, null, null, null, null, null, null, null, null, states);
  }
};

export default detectFaceAndEyesV2;
